import { Attributo } from './attributi';
import { OptionList, OptionVariant } from './cart_articolo_option';
import { Livello, RigaLivello } from './componibili';
import { Confezione } from './confezioni';
import { Ingrediente } from './ingredienti';

export interface Articolo {
    identificativo_azienda: string,
    ragione_sociale: string,
    codart: string,
    descart: string,
    descrizione_estesa: string,
    prezzo: number,
    prezzo_originale: number,
    famiglia: string,
    reviews: number,
    cdn_url: string,
    latitudine: number,
    longitudine: number,
    tipo_prezzo: number,
    scadenza_promozionale: string,
    tipo_articolo: number,
    disponibilita_prodotto: number,
    data_creazione: string,
    data_ultima_modifica: string,
    acquisti_giacenza_negativa: boolean,
    non_acquistabile: boolean,
    ingredienti: Ingrediente[],
    livello_riordino: number,
    minimo_acquisto: number,
    canali: [{canale: number, prezzo: number}],
    immagine_principale: number
}

export interface ArticoloFull {
    disponibilita_prodotto: number;
    identificativo_azienda: string,
    codart: string,
    descart: string,
    descrizione_estesa: string,
    aliquota: string,
    um: string,
    famiglia: string,
    sottofamiglia: string,
    gruppo: string,
    sottogruppo: string,
    marca: string,
    prezzo: number,
    prezzo_originale: number,
    minimo_acquisto: number,
    livello_riordino: number,
    tipo_prezzo: number,
    scadenza_promozionale: string,
    tipo_articolo: number,
    produttore: any,
    cdn_url: string,
    image_gallery: any,
    barcode_principale: string,
    categoria_principale: number,
    option_list1: number,
    option_list2: number,
    option_list3: number,
    option_list4: number,
    optionlist1: OptionList,
    optionlist2: OptionList,
    optionlist3: OptionList,
    optionlist4: OptionList,
    azienda_prodotto: {
        identificativo_azienda: string,
        codice_fiscale: string,
        partitaIva: string,
        ragioneSociale: string,
        citta: string,
        cap: string,
        indirizzo: string,
        codiceComune: string,
        provincia: string,
        stato: number,
        email: string,
        contattoTelefonico: string,
        credenzialiApi: string,
        tipoUtente: number,
        nameServer: string,
        defaultDitta: string,
        codiceAziendale: string,
        nomeUnivoco: string,
        abbonamento: number,
        scadenza: string,
        stripe_code: string,
        impostazioni_consegna: {
            attivo: boolean,
            finestra: number,
            tipo_data: number,
            flg_fascia: boolean,
            flg_note: boolean,
            flg_obb_data: boolean,
            flg_obb_fascia: boolean,
            flg_now_compreso: boolean
        },
        cdn_type: number,
        labelIndirizzoBackgroundColor: string,
        textLabelSpedizioneColor: string,
        textHomeColor: string,
        backgroundHomeColor: string,
        backgroundHomeColor2: string,
        searchBarColor: string,
        latitudine: number,
        longitudine: number,
        altitudine: number,
        categoria_principale: number,
        dominio: number,
        logo_url: string,
        banner: string,
        message_to_user: string,
        stripe_is_ok: boolean
    },
    reviews: number,
    option_disponibili_1: OptionVariant[],
    option_disponibili_2: OptionVariant[],
    option_disponibili_3: OptionVariant[],
    option_disponibili_4: OptionVariant[],
    non_prenotabile: boolean,
    non_acquistabile: boolean,
    prenotazioni_giacenza_negativa: boolean,
    acquisti_giacenza_negativa: boolean,
    giacenze: {
        giacenza: {
            codice_articolo: string,
            cf_azienda: string,
            deposito: string,
            giacenza: number
        },
        giacenza_opt: any[]
    },
    schede_articolo: any[],
    ingredienti: Ingrediente[],
    calcolo_prezzo: CALCOLO_PREZZO,
    flg_esplosione: ESPLOSIONE,
    mod_calcolo_prezzo: MOD_CALCOLO_PREZZO,
    livelli_composizione?: Livello[],
    composizione_articolo?: RigaLivello[],
    attributi?: Attributo[],
    confezioni_articolo?: Confezione[],
    conf_active?: Confezione,

}

export enum CALCOLO_PREZZO {
    DA_PADRE = 0,
    PUNTUALE = 1
}

/// Il flag definisce quale tra le righe tra padre e figlio deve essere inserita come riga descrittiva. In caso sia il padre, vuol dire che il padre viene inserito
/// come descrittivo, mentre i figli vengono riportati puntualmente e viceversa.
export enum ESPLOSIONE { 
    PADRE = 0,
    FIGLI = 1
}

export enum MOD_CALCOLO_PREZZO {
    PERCENTUALE = 0,
    COMPOSIZIONE = 1
}

enum TipoArticolo {

    Articolo = 1,
    ArticoloPeso = 2,
    ArticoloPackaging = 3,
    ArticoloRicetta = 4,
    BoxSemplice = 5,
    BoxComponibile = 6

}